import { type FC } from 'react';
import { OrderInboundsDetailEmlAttachmentListItem } from './order-inbounds-detail-eml-attachment-list-item';
import { StyleSheet, View } from 'react-native';
import type { InboundAttachment } from '@/components/attachment-list/attachment-list-types';
import type { OnAttachmentListItemPressCallback } from '@/screens/order-inbounds/order-inbounds-detail-tabs/types';
import type { OrderMetadata } from '@/screens/order-inbounds/types';

interface OrderInboundsDetailEmlAttachmentListProps {
  attachments: InboundAttachment[];
  onItemPress: OnAttachmentListItemPressCallback;
  order: OrderMetadata;
}

export const OrderInboundsDetailEmlAttachmentList: FC<
  OrderInboundsDetailEmlAttachmentListProps
> = ({ attachments, onItemPress, order }) => {
  return (
    <View style={styles.container}>
      {attachments.map((attachment) => (
        <OrderInboundsDetailEmlAttachmentListItem
          attachment={attachment}
          key={attachment.url}
          onPress={onItemPress}
          order={order}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
});
